import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { dashboardAPI, adminAPI } from '../../services/api';
import toast from 'react-hot-toast';
import StatCard from '../../components/common/StatCard';
import ChartComponent from '../../components/common/ChartComponent';

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    totalStaff: 0,
    totalStudents: 0,
    totalClasses: 0,
    totalSubjects: 0,
    activeSessions: 0,
    pendingAssessments: 0
  });
  
  const [recentActivities, setRecentActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      
      // Fetch statistics
      // const [statsRes, staffRes, studentsRes, classesRes, subjectsRes] = await Promise.all([
      const [staffRes, studentsRes, classesRes, subjectsRes] = await Promise.all([
        
        adminAPI.getStaff(),
        adminAPI.getStudents(),
        adminAPI.getClasses(),
        adminAPI.getSubjects()
      ]);

      // console.log(statsRes);

      setStats({
        totalStaff: staffRes.data.length,
        totalStudents: studentsRes.data.length,
        totalClasses: classesRes.data.length,
        totalSubjects: subjectsRes.data.length,
        activeSessions: 0,
        pendingAssessments: 0
      });



    } catch (error) {
      toast.error('Failed to load dashboard data');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Welcome Banner */}
      <div className="bg-gradient-to-r from-primary-600 to-primary-800 rounded-xl p-6 text-gray-700">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold">Welcome back, Admin!</h1>
            <p className="opacity-90 mt-1">Here's what's happening with your school today.</p>
          </div>
          <div className="hidden md:block">
            <i className="fas fa-school text-5xl opacity-20"></i>
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Link 

        style={{ textDecoration: "none" }}
          to="/admin/staff"
          className="bg-white p-4 rounded-lg shadow hover:shadow-md transition-shadow border border-gray-200 hover:border-primary-300"
        >
          <div className="flex items-center">
            <div className="p-3 bg-primary-100 rounded-lg mr-4">
              <i className="fas fa-users text-primary-600 text-xl"></i>
            </div>
            <div>
              <p className="text-sm text-gray-500">Manage Staff</p>
              <p className="font-semibold">Add/Edit Staff Members</p>
            </div>
          </div>
        </Link>

        <Link 

        style={{ textDecoration: "none" }}

          to="/admin/students"
          className="bg-white p-4 rounded-lg shadow hover:shadow-md transition-shadow border border-gray-200 hover:border-primary-300"
        >
          <div className="flex items-center">
            <div className="p-3 bg-green-100 rounded-lg mr-4">
              <i className="fas fa-graduation-cap text-green-600 text-xl"></i>
            </div>
            <div>
              <p className="text-sm text-gray-500">Manage Students</p>
              <p className="font-semibold">Register Students</p>
            </div>
          </div>
        </Link>

        <Link 

        style={{ textDecoration: "none" }}


          to="/admin/assessment-config"
          className="bg-white p-4 rounded-lg shadow hover:shadow-md transition-shadow border border-gray-200 hover:border-primary-300"
        >
          <div className="flex items-center">
            <div className="p-3 bg-purple-100 rounded-lg mr-4">
              <i className="fas fa-cog text-purple-600 text-xl"></i>
            </div>
            <div>
              <p className="text-sm text-gray-500">Assessment Config</p>
              <p className="font-semibold">Configure Fields</p>
            </div>
          </div>
        </Link>

        <Link 

        style={{ textDecoration: "none" }}
        
          to="/admin/classes"
          className="bg-white p-4 rounded-lg shadow hover:shadow-md transition-shadow border border-gray-200 hover:border-primary-300"
        >
          <div className="flex items-center">
            <div className="p-3 bg-yellow-100 rounded-lg mr-4">
              <i className="fas fa-school text-yellow-600 text-xl"></i>
            </div>
            <div>
              <p className="text-sm text-gray-500">Classes</p>
              <p className="font-semibold">Manage Classes</p>
            </div>
          </div>
        </Link>
      </div>

      {/* Statistics Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <StatCard
          title="Total Staff"
          value={stats.totalStaff}
          icon="fa-users"
          color="primary"
          change="+12%"
        />
        <StatCard
          title="Total Students"
          value={stats.totalStudents}
          icon="fa-graduation-cap"
          color="green"
          change="+8%"
        />
        <StatCard
          title="Total Classes"
          value={stats.totalClasses}
          icon="fa-school"
          color="yellow"
          change="+3%"
        />
        <StatCard
          title="Total Subjects"
          value={stats.totalSubjects}
          icon="fa-book"
          color="purple"
          change="+5%"
        />
        {/* <StatCard
          title="Active Sessions"
          value={stats.activeSessions}
          icon="fa-calendar"
          color="blue"
          change="+2"
        />
        <StatCard
          title="Pending Assessments"
          value={stats.pendingAssessments}
          icon="fa-tasks"
          color="red"
          change="-4"
        /> */}
      </div>

      {/* Charts and Recent Activities */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Chart */}
        {/* <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">Student Enrollment Trend</h3>
          <div className="h-64">
            <ChartComponent
              type="line"
              data={{
                labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
                datasets: [
                  {
                    label: 'New Students',
                    data: [65, 78, 90, 85, 95, 110],
                    borderColor: '#3b82f6',
                    backgroundColor: 'rgba(59, 130, 246, 0.1)',
                  }
                ]
              }}
            />
          </div>
        </div> */}

        {/* Recent Activities */}
        {/* <div className="bg-white rounded-lg shadow p-6">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold text-gray-800">Recent Activities</h3>
            <Link to="/admin/activities" className="text-sm text-primary-600 hover:text-primary-700">
              View all
            </Link>
          </div>
          <div className="space-y-4">
            {recentActivities.map((activity) => (
              <div key={activity.id} className="flex items-start space-x-3 p-3 hover:bg-gray-50 rounded-lg">
                <div className="flex-shrink-0">
                  <div className="w-8 h-8 bg-primary-100 rounded-full flex items-center justify-center">
                    <i className="fas fa-bell text-primary-600 text-sm"></i>
                  </div>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900">{activity.action}</p>
                  <p className="text-sm text-gray-500">by {activity.user}</p>
                </div>
                <div className="text-xs text-gray-400">{activity.time}</div>
              </div>
            ))}
          </div>
        </div> */}
      </div>

      {/* System Status */}
      {/* <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">System Status</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="border rounded-lg p-4">
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">Database</span>
              <span className="px-2 py-1 text-xs rounded-full bg-green-100 text-green-800">
                <i className="fas fa-check-circle mr-1"></i> Online
              </span>
            </div>
          </div>
          <div className="border rounded-lg p-4">
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">API Server</span>
              <span className="px-2 py-1 text-xs rounded-full bg-green-100 text-green-800">
                <i className="fas fa-check-circle mr-1"></i> Running
              </span>
            </div>
          </div>
          <div className="border rounded-lg p-4">
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">Storage</span>
              <span className="px-2 py-1 text-xs rounded-full bg-yellow-100 text-yellow-800">
                <i className="fas fa-exclamation-triangle mr-1"></i> 78%
              </span>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default AdminDashboard;